'use es6';
/* eslint-disable react/no-unused-prop-types */

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { mapStateToProps as mapEditorErrorsStateToProps } from 'DesignComponents/statusBar/connect/editorErrors';
import EditorError from 'DesignData/models/validation/EditorError';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
import MessagesList from './MessagesList';
import ResizablePanes from 'DesignComponents/resizablePanes/ResizablePanes';
import Pane from 'DesignComponents/resizablePanes/Pane';
import { MIN_PANE_SIZE } from 'DesignData/constants/PaneSizes';
import { VERTICAL } from 'DesignData/enums/AxisDirections';
const PRIMARY_MESSAGE_PROPS = ['primaryErrors', 'primaryWarnings', 'primaryInfo', 'primarySuccesses'];
const SPLIT_MESSAGE_PROPS = ['splitErrors', 'splitWarnings', 'splitInfo', 'splitSuccesses'];

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {
    isDrawerOpen: ownProps.isDrawerOpen,
    hasMessages: stateProps.hasMessages,
    hasPrimaryMessages: stateProps.hasPrimaryMessages,
    hasSplitMessages: stateProps.hasSplitMessages,
    showSplitScreen: stateProps.showSplitScreen,
    primaryErrors: stateProps.primaryErrors,
    primaryWarnings: stateProps.primaryWarnings,
    primaryInfo: stateProps.primaryInfo,
    primarySuccesses: stateProps.primarySuccesses,
    splitErrors: stateProps.splitErrors,
    splitWarnings: stateProps.splitWarnings,
    splitInfo: stateProps.splitInfo,
    splitSuccesses: stateProps.splitSuccesses
  };
}

class StatusBarDrawer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldRender: false
    };
    this.setPrimaryList(props);
    this.setSplitList(props);
    this.state.shouldRender = props.isDrawerOpen;
  }

  componentDidUpdate(prevProps) {
    const {
      isDrawerOpen
    } = this.props;

    if (prevProps.isDrawerOpen && !isDrawerOpen) {
      setTimeout(() => {
        if (isDrawerOpen) return;
        this.setState({
          shouldRender: false
        });
      }, 300);
    } else if (!prevProps.isDrawerOpen && isDrawerOpen) {
      this.setState({
        shouldRender: true
      });
    }

    if (!PRIMARY_MESSAGE_PROPS.every(name => this.props === prevProps[name])) {
      this.setPrimaryList(this.props);
    }

    if (!SPLIT_MESSAGE_PROPS.every(name => this.props === prevProps[name])) {
      this.setSplitList(this.props);
    }
  }

  setPrimaryList(props) {
    this.primaryList = props.hasPrimaryMessages ? EMPTY_ARRAY.concat(props.primaryErrors, props.primaryWarnings, props.primaryInfo, props.primarySuccesses) : EMPTY_ARRAY;
    return this.primaryList;
  }

  setSplitList(props) {
    this.splitList = props.hasSplitMessages && props.showSplitScreen ? EMPTY_ARRAY.concat(props.splitErrors, props.splitWarnings, props.splitInfo, props.splitSuccesses) : EMPTY_ARRAY;
    return this.splitList;
  }

  render() {
    if (!this.state.shouldRender) {
      return null;
    }

    if (!this.props.hasMessages) {
      return null;
    }

    const primaryMessages = this.props.hasPrimaryMessages ? /*#__PURE__*/_jsx(MessagesList, {
      list: this.primaryList
    }) : EMPTY_ARRAY;

    if (!(this.props.hasSplitMessages && this.props.showSplitScreen)) {
      return primaryMessages;
    }

    return /*#__PURE__*/_jsxs(ResizablePanes, {
      paneMinSize: MIN_PANE_SIZE,
      direction: VERTICAL,
      children: [/*#__PURE__*/_jsx(Pane, {
        paneId: "0",
        direction: VERTICAL,
        children: primaryMessages
      }, "0"), /*#__PURE__*/_jsx(Pane, {
        paneId: "1",
        direction: VERTICAL,
        children: /*#__PURE__*/_jsx(MessagesList, {
          list: this.splitList
        })
      }, "1")]
    });
  }

}

StatusBarDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  hasMessages: PropTypes.bool.isRequired,
  hasPrimaryMessages: PropTypes.bool.isRequired,
  hasSplitMessages: PropTypes.bool.isRequired,
  showSplitScreen: PropTypes.bool.isRequired,
  primaryErrors: EditorError.editorErrorArrayPropType.isRequired,
  primaryWarnings: EditorError.editorErrorArrayPropType.isRequired,
  primaryInfo: EditorError.editorErrorArrayPropType.isRequired,
  primarySuccesses: EditorError.editorErrorArrayPropType.isRequired,
  splitErrors: EditorError.editorErrorArrayPropType.isRequired,
  splitWarnings: EditorError.editorErrorArrayPropType.isRequired,
  splitInfo: EditorError.editorErrorArrayPropType.isRequired,
  splitSuccesses: EditorError.editorErrorArrayPropType.isRequired
};
export default connect(mapEditorErrorsStateToProps, null, mergeProps)(StatusBarDrawer);